import {
  LAMBDATEST_REQUEST_INFINITE_LOADING,
  LAMBDATEST_REQUEST_INFINITE_SUCCESS,
  LAMBDATEST_REQUEST_INFINITE_FAILED,
  LAMBDATEST_REQUEST_INFINITE_SILENT_LOADING,
  LAMBDATEST_REQUEST_LOADING,
  LAMBDATEST_REQUEST_SUCCESS,
  LAMBDATEST_REQUEST_FAILED,
  LAMBDATEST_REQUEST_DATA_CLEAR,
  LAMBDATEST_ADD_SANITIZED_COMMANDS,
  LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_LOADING,
  LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_SUCCESS,
  LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_FAILED,
  FETCH_COMMAND_LOG_COUNT_SUCCESS,
  FETCH_COMMAND_LOG_COUNT_FAILED,
  LAMBDATEST_ADD_CDP_REQUEST_LOGS_SSE,
  LAMBDATEST_REPLACE_COMMAND_LOGS_SSE,
  LAMBDATEST_ALL_COMMAND,
  LAMBDATEST_UPDATE_COMMAND_RERUN_EXECUTION_STATUS,
  SET_EXPANDED_ANNOTATIONS,
  SET_EXPANDED_COMMAND_LOGS
} from "../../actionTypeConstants/ml2.0/CommandLogs";

import createRestApiClient from "../../../utility/createRestApiClient";
import { getCookieData } from "../../../utility/cookieHandler/handler";
import { TestTypes } from "../../../common/constants/View.js";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import {
  appendParamsToUrl,
  isWasabiEnabledForCurrentOrg,
  getApiBaseUrl,
  getUrlByUserDomain,
  isCDPTest,
  isSharingRoute,
  isTestADemoTest,
  isNewAnnotationFlowEnabled
} from "../../../utility/utilityFunctions";
import {
  ANNOTATION_SEPARATOR,
  isMobileDevice
} from "../../../utility/testHelpers";
import axios from "axios";

const CancelToken = axios.CancelToken;
let source;

const HOST = `${getUrlByUserDomain(
  process.env.REACT_APP_DEBUGGER_HOST_PREFIX,
  "https",
  process.env.REACT_APP_HIDE_PUBLIC_LINKS
)}/getLogs`;

export let currentOffsetValue = 0;
const REQUEST_SUFFIX = process.env.REACT_APP_MOCK_REQUEST_SUFFIX;
const apiClient = createRestApiClient().withConfig({
  baseURL: HOST
}).client;

/*
 *This action is using in new dashboard ui for infinite scroll of command log
 */

export function cancelPreviousRequest() {
  if (source) {
    source.cancel();
  }
  return dispatch =>
    dispatch({
      type: LAMBDATEST_REQUEST_DATA_CLEAR
    });
}

export const commandlogsSet = count => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_ALL_COMMAND,
      payload: count
    });
};

export function fetchRequestDataNew({
  areCommandLogsFetchedFromLTMA = false,
  automationLogsHost = null,
  hubRegionInitial = "",
  isCDPRetryCall = false,
  isExceptionLog = false,
  jenkins = false,
  orgId,
  pageIndex = 0,
  pageChunkSize,
  silentlyUpdateLogs = false,
  shareId = null,
  testId,
  testDate = null,
  testType = "desktop",
  testDetails = {},
  userInfo = {},
  filters = {},
  isMobileCmdLogV2Enabled = false,
  annotationId = null,
  annotationIndex = null
}) {
  const isRealMobile = get(testDetails, "isRealMobile", false);
  const featureFlags = get(testDetails, "feature_flag", {});
  const mobile = isMobileDevice(testDetails);
  source = CancelToken.source();

  const isCDP = isCDPTest(testDetails.type);
  let isServerPagination = testDetails
    ? isCDP ||
      (testDetails.type !== TestTypes.CYPRESS && !isRealMobile) ||
      (testDetails.type !== TestTypes.CYPRESS &&
        isRealMobile &&
        isMobileCmdLogV2Enabled)
    : true;
  currentOffsetValue = pageIndex;

  let endPoint =
    testDetails.type === "cypress"
      ? `/${testId}/cypress_json`
      : `/${testId}/${REQUEST_SUFFIX}`;

  if (testDate) {
    if (isCDP && areCommandLogsFetchedFromLTMA) {
      endPoint =
        endPoint + `?testDate=${testDate}&testType=${testDetails.type}`;
    } else {
      endPoint = endPoint + `?testDate=${testDate}&testType=${testType}`;
    }
  }

  if (isServerPagination) {
    let queryParamToAdd = "commandLogrefactor=true";
    if (
      testDetails.type === TestTypes.SELENIUM ||
      (isCDP && automationLogsHost && testDetails.mode === "hypertest")
    ) {
      queryParamToAdd = "commandLogv2=true";
    }
    endPoint =
      endPoint +
      `&pageNumber=${pageIndex +
        1}&logsPerPage=${pageChunkSize}&${queryParamToAdd}`;
  }
  if (testDetails.type !== TestTypes.CYPRESS) {
    endPoint = endPoint + `&isExceptionLog=${isExceptionLog}`;
  }
  if (annotationId) {
    endPoint = endPoint + `&annotationID=${annotationId}`;
  }
  const isContextFilterApplied = filters?.annotations?.length > 0;
  if (filters && !isEmpty(filters)) {
    Object.keys(filters).forEach(function(k) {
      if (filters[k]) {
        if (filters[k] instanceof Array) {
          if (filters[k]?.length > 0) {
            // Encode each value in the array
            const encodedValues = filters[k].map(value =>
              encodeURIComponent(value)
            );

            let encodedString = "";

            if (k === "annotations") {
              // Join with ~ in case of annotations as there could be commas in annotation name and be will split on ~
              encodedString = encodedValues.join(ANNOTATION_SEPARATOR);
            } else {
              // Join the encoded values with commas
              encodedString = encodedValues.join(",");
            }

            // Append to the endPoint without encoding the key
            endPoint = `${endPoint}&${k}=${encodedString}`;
          }
        }
      }
    });
  }

  let token = null;
  if (jenkins) {
    token =
      getCookieData("lambdaToken") ||
      (jenkins.accessKeyData && jenkins.accessKeyData.apiToken);
    let username =
      getCookieData("username") ||
      (jenkins.accessKeyData && jenkins.accessKeyData.username);
    endPoint = `${endPoint}?jenkins=true&username=${username}`;
    if (testDate) {
      endPoint = endPoint + `&testDate=${testDate}`;
    }
    if (!token) {
      window.location.href =
        process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
    }
  } else {
    let cookieName = process.env.REACT_APP_COOKIE_NAME;
    token = getCookieData(cookieName);
  }
  if (hubRegionInitial) {
    endPoint = endPoint + `&hubRegionInitial=${hubRegionInitial}`;
  }
  const isNewAnnotationFlow = isNewAnnotationFlowEnabled(testDetails);

  if (isNewAnnotationFlow) {
    endPoint = endPoint + `&isAnnotationNew=true`;
  }

  // Set environment variable inside test details.
  testDetails["environment"] = {
    category: testDetails["category"] || ""
  };

  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);

  const { updatedApiClient, updatedEndPoint } = appendParamsToUrl({
    endPoint,
    mobile,
    orgId,
    testDetails,
    type: "commandLogs",
    testType,
    automationLogsHost,
    areLogsFetchedFromLTMA: areCommandLogsFetchedFromLTMA,
    isCDP
  });

  let types = [];
  if (isServerPagination) {
    types = [
      LAMBDATEST_REQUEST_INFINITE_LOADING,
      LAMBDATEST_REQUEST_INFINITE_SUCCESS,
      LAMBDATEST_REQUEST_INFINITE_FAILED
    ];
  }
  if (silentlyUpdateLogs === true) {
    types = [
      LAMBDATEST_REQUEST_INFINITE_SILENT_LOADING,
      LAMBDATEST_REQUEST_INFINITE_SUCCESS,
      LAMBDATEST_REQUEST_INFINITE_FAILED
    ];
  } else if (!isServerPagination) {
    types = [
      LAMBDATEST_REQUEST_LOADING,
      LAMBDATEST_REQUEST_SUCCESS,
      LAMBDATEST_REQUEST_FAILED
    ];
  }

  const sharingLinkAuthHeader = {
    "x-ml-auth": shareId,
    "x-ml-user": "sharing-client"
  };

  const header = shareId
    ? sharingLinkAuthHeader
    : areCommandLogsFetchedFromLTMA
    ? {
        Authorization: `Basic ` + btoa(username + ":" + accessKey)
      }
    : {
        "x-ml-auth": token
      };

  return {
    payload: {
      isCDPRetryCall,
      isCDPTest: isCDP,
      isDesktopTest: testType === "desktop",
      isDemoTest: testDetails && isTestADemoTest(testDetails?.id),
      isFetchFromLTMA: areCommandLogsFetchedFromLTMA,
      pageChunkSize,
      pageNumber: pageIndex,
      testType,
      filters,
      isMobileCmdLogV2Enabled,
      testDetails,
      isAnnotation: annotationId ? true : false,
      annotationId: annotationId,
      annotationIndex: annotationIndex,
      isContextFilterApplied: isContextFilterApplied
    },
    types: types,
    promise: () =>
      updatedApiClient.get(`${updatedEndPoint}`, {
        headers: header,
        cancelToken: source.token
      })
  };
}

/*
 * This action fetches the number of command logs present in the db
 */
export const fetchCommandLogCount = ({
  createdAt,
  hubRegionInitial = "",
  orgId,
  shareId = "",
  testId,
  testDate = null,
  testType = "desktop",
  testDetails = {},
  userInfo = {},
  isException = false,
  logType = "request",
  logsPerPage
}) => {
  const isCDP = isCDPTest(testDetails.type);

  let endPoint = `${getApiBaseUrl('https', null, true)}/automation/api/v1/list/${testId}/${logType}?testDate=${testDate}&testType=${testType}&hubRegionInitial=${hubRegionInitial}&orgId=${orgId}&testCreateTimestamp=${createdAt}`;

  if (testDetails?.isRealMobile === 1) {
    endPoint += "&isRealMobile=1";
  }
  const isNewAnnotationFlow = isNewAnnotationFlowEnabled(testDetails);

  if (isCDP) {
    endPoint = `${getApiBaseUrl('https', null, true)}/automation/api/v1/list/${testId}/${logType}?testDate=${testDate}&testType=${
      testDetails.type
    }&hubRegionInitial=${hubRegionInitial}&orgId=${orgId}&testCreateTimestamp=${createdAt}`;
  }
  if (isNewAnnotationFlow) {
    endPoint += `&isAnnotationNew=true`;
  }

  if (isWasabiEnabledForCurrentOrg({ testDetails })) {
    endPoint += "&isWasabiEnabled=true";
  }
  if (testDetails && (testDetails.type === "selenium" || isCDP)) {
    endPoint += `&commandLogv2=true`;
  }
  if (isException) {
    endPoint += `&isExceptionLog=true`;
  }
  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  const token = getCookieData(cookieName);
  if (!token && !isSharingRoute()) {
    window.location.href =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
  }
  const username = get(userInfo, ["data", "username"], null);
  const accessKey = get(userInfo, ["data", "apiToken"], null);
  let headersToPass = {};
  if (shareId) {
    headersToPass = {
      "x-ml-auth": shareId,
      "x-ml-user": "sharing-client"
    };
  } else {
    headersToPass = {
      Authorization: `Basic ` + btoa(username + ":" + accessKey)
    };
  }
  return {
    types: [
      LAMBDATEST_REQUEST_INFINITE_LOADING,
      FETCH_COMMAND_LOG_COUNT_SUCCESS,
      FETCH_COMMAND_LOG_COUNT_FAILED
    ],
    pageChunkSize: logsPerPage,
    testDetails,
    promise: () =>
      apiClient.get(`${endPoint}`, {
        headers: headersToPass
      })
  };
};

export const setExpandedAnnotations = (index, value) => {
  return dispatch =>
    dispatch({
      type: SET_EXPANDED_ANNOTATIONS,
      payload: { index, value }
    });
};

export const setExpandedCommandLogs = (annotationIndex, commandIndex) => {
  return dispatch =>
    dispatch({
      type: SET_EXPANDED_COMMAND_LOGS,
      payload: { annotationIndex, commandIndex }
    });
};
/**
 *
 * @param {*} accessKey
 * @param {*} shareId
 * @param {*} testId
 * @param {*} userName
 * @returns assertion error logs for a test
 */
export function fetchFrameworkExceptionData({
  automationApiHost,
  accessKey,
  shareId = null,
  testId,
  username
}) {
  const exceptionLogsEndpoint = automationApiHost || getApiBaseUrl();
  const exceptionLogsApiClient = createRestApiClient().withConfig({
    baseURL: exceptionLogsEndpoint
  }).client;
  const endPoint = `automation/api/v1/test/${testId}/exceptions`;

  const types = [
    LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_LOADING,
    LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_SUCCESS,
    LAMBDATEST_FRAMEWORK_EXCEPTION_LOGS_FAILED
  ];
  const headerObject = shareId
    ? {
        headers: {
          "x-ml-auth": shareId,
          "x-ml-user": "sharing-client"
        }
      }
    : {
        auth: {
          username: username,
          password: accessKey
        }
      };
  return {
    types: types,
    promise: () => exceptionLogsApiClient.get(`${endPoint}`, headerObject)
  };
}

export const clearRequestLogs = () => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_REQUEST_DATA_CLEAR
    });
};

export const setCommandLogsLoading = () => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_REQUEST_INFINITE_LOADING
    });
};

export const setSanitizedCommandLogs = data => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_ADD_SANITIZED_COMMANDS,
      payload: data
    });
};

export const addRealtimeCommandLog = data => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_ADD_CDP_REQUEST_LOGS_SSE,
      payload: data
    });
};

export const replaceRealtimeCommandLog = (event, data) => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_REPLACE_COMMAND_LOGS_SSE,
      payload: { event, data }
    });
};

export const updateCommandRerunExecutionStatus = data => {
  return dispatch =>
    dispatch({
      type: LAMBDATEST_UPDATE_COMMAND_RERUN_EXECUTION_STATUS,
      payload: data
    });
};
